module.exports = new __parcel__URL__("shop_other_button.4b1ef3dc.png").toString();